import { formatDate } from "@clipboard-health/date-time";
import { BottomSheet, Text, type UseModalState } from "@clipboard-health/ui-components";
import { Box, DialogContent, Stack } from "@mui/material";

import { CbhFeatureFlag } from "../../../FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../../../FeatureFlags/useCbhFlag";
import { PRIORITY_ACCESS_COLOR } from "../../../lib/Theme/constants";
import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";

interface ReactivationBonusBottomSheetProps {
  modalState: UseModalState;
}

export function ReactivationBonusBottomSheet({ modalState }: ReactivationBonusBottomSheetProps) {
  const reactivationBonusBanner = useCbhFlag(CbhFeatureFlag.REACTIVATION_BONUS_BANNER, {
    defaultValue: false,
  });

  // June 15, 2025
  const deadlineDate = new Date(2025, 5, 15);

  if (!reactivationBonusBanner) {
    return null;
  }

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: PRIORITY_ACCESS_COLOR,
              "&:hover": {
                backgroundColor: PRIORITY_ACCESS_COLOR,
                opacity: 0.9,
              },
            }}
            onClick={modalState.closeModal}
          >
            Got it
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent>
        <Box sx={{ p: 2 }}>
          <Text variant="h2" sx={{ mb: 2, textAlign: "center" }}>
            We missed you!
          </Text>
          <Stack spacing={2} alignItems="center">
            <Text variant="body1" sx={{ textAlign: "center" }}>
              Get a $50 bonus after completing your next shift. Bonus valid for one shift only, and
              payable within 24 hours of shift completion.
            </Text>
            <Text variant="body1" sx={{ textAlign: "center" }}>
              First shift must be completed by {formatDate(deadlineDate)}.
            </Text>
          </Stack>
        </Box>
      </DialogContent>
    </BottomSheet>
  );
}
